import React from "react";

const withLoadingError = (Component) => (props) => {
  if (props.loading) return <div>Loading data...</div>;
  if (props.error) return <div>An error was found</div>;
  if (!props.data) return <div>Data is empty.</div>;

  return <Component {...props} />;
};

export default withLoadingError;
